import React, { useEffect, useState } from 'react';
import './Combo.css';
import Form from 'react-bootstrap/Form';
import 'bootstrap/dist/css/bootstrap.min.css';
import { useNavigate } from 'react-router-dom';

const ComboProductPage = () => {
  const [combos, setCombos] = useState([]);
  const [sortOption, setSortOption] = useState('default');
  const [cart, setCart] = useState(() => {
    const savedCart = localStorage.getItem('cartItems');
    return savedCart ? JSON.parse(savedCart) : [];
  });

  const navigate = useNavigate();

  useEffect(() => {
    fetch('/sweets.json')
      .then(res => res.json())
      .then(data => {
        const comboItems = data.sweets.filter(item => item.category === 'Combo');
        setCombos(comboItems);
      })
      .catch(err => console.error('Combo fetch error:', err));
  }, []);

  useEffect(() => {
    localStorage.setItem('cartItems', JSON.stringify(cart));
  }, [cart]);

  const handleSort = (a, b) => {
    if (sortOption === 'low-high') return a.price - b.price;
    if (sortOption === 'high-low') return b.price - a.price;
    if (sortOption === 'a-z') return a.name.localeCompare(b.name);
    if (sortOption === 'popularity') return (b.rating || 0) - (a.rating || 0);
    return 0;
  };

  const sortedCombos = [...combos].sort(handleSort);

  const addToCart = (product) => {
    setCart(prevCart => {
      const exists = prevCart.find(item => item.id === product.id);
      if (exists) {
        return prevCart.map(item =>
          item.id === product.id ? { ...item, quantity: item.quantity + 1 } : item
        );
      } else {
        return [...prevCart, { ...product, quantity: 1 }];
      }
    });
  };

  const goToCart = () => {
    navigate('/cart');
  };

  return (
    <div className="container">
      <h1 className="header">Combos</h1>

      <div className="filter-container">
        <Form.Select
          className="select"
          onChange={(e) => setSortOption(e.target.value)}
          value={sortOption}
        >
          <option value="default">Sort By</option>
          <option value="low-high">Price: Low to High</option>
          <option value="high-low">Price: High to Low</option>
          <option value="popularity">Popularity</option>
          <option value="a-z">A-Z</option>
        </Form.Select>

        <button className="btn btn-success" onClick={goToCart}>
          🛒 Cart ({cart.reduce((acc, item) => acc + item.quantity, 0)})
        </button>
      </div>

      <div className="grid">
        {sortedCombos.map((product) => (
          <div key={product.id} className="product-card">
            <img src={product.image} alt={product.name} className="product-image" />
            <h5 className="product-title">{product.name}</h5>
            <p className="weight">Combo Pack</p>
            <div className="rating">
              ⭐⭐⭐⭐☆ <span className="rating-value">({product.rating || 4.5})</span>
            </div>
            <p className="product-description">{product.description}</p>
            <p className="price">Price: ₹{product.price}</p>
            <button className="btn btn-primary" onClick={() => addToCart(product)}>
              Add to Cart
            </button>
          </div>
        ))}
      </div>
    </div>
  );
};

export default ComboProductPage;
